import DaysReadingCountCount from './DaysReadingCount';

export default DaysReadingCountCount;
